import './_footer.scss';
import { responsive, debounce } from '../../../utilities';

$(() => {
    const $footers = $('.footer');
    if (!$footers.length) {
        return;
    }
    function resize() {
        $footers.each((_, footer) => {
            const $footer = $(footer);
            const $footerContainer = $footer.find('.footer__container');
            $footerContainer.removeAttr('style');

            responsive.breakAt({
                callback: () => {
                    responsive.overflownTextScale($footerContainer.get(0));
                },
                to: 'md',
            });
        });
    }
    resize();
    window.addEventListener('resize', debounce(resize, 300));
});
